import React from 'react';
import { BookOpenIcon, CheckIcon, FlowerIcon, HandHeartIcon } from 'lucide-react';
import { steps, stepsTagline } from '../data/content';
const stepIcons = [BookOpenIcon, FlowerIcon, HandHeartIcon, CheckIcon];
export function HowItWorks() {
  return <section className="bg-rose-wash text-ink" data-id="element-123" data-mp="3q0b3gljdmxba">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-6 lg:py-24" data-id="element-124" data-mp="3tzjxzsm8qz7w">
        <div className="mx-auto max-w-2xl text-center" data-id="element-125" data-mp="lk9zeuhk8c4v">
          <p className="font-sans text-[0.7rem] font-semibold uppercase tracking-[0.24em] text-gold-deep" data-id="element-126" data-mp="lktjagqrtalj">
            Cómo funciona
          </p>
          <h2 className="mt-3 font-display text-[2.1rem] font-semibold leading-tight text-brown sm:text-5xl" data-id="element-127" data-mp="crye1n1azevr">
            De la Palabra <span className="font-script font-normal text-rose" data-id="element-128" data-mp="gsrxa33sw5ib">a tu vida</span>
          </h2>
          <p className="mt-4 font-sans text-[0.98rem] leading-relaxed text-ink-soft sm:text-[1.05rem]" data-id="element-129" data-mp="14iw1ocotc9ad">
            Cada día recorres el mismo camino sencillo, para que lo que lees empiece a hacerse parte
            de tu día.
          </p>
        </div>

        <ol className="mx-auto mt-12 max-w-md lg:grid lg:max-w-none lg:grid-cols-4 lg:gap-8" data-id="element-130" data-mp="2rjlc5527zfyy">
          {steps.map((step, index) => {
          const Icon = stepIcons[index];
          const isLast = index === steps.length - 1;
          return <li key={step.title} className="relative flex gap-5 pb-9 last:pb-0 lg:flex-col lg:items-center lg:pb-0 lg:text-center" data-id="element-131" data-mp="2wk8xpb7oj4ls" data-mpi={index}>
                {!isLast && <>
                    <span aria-hidden="true" className="absolute bottom-0 left-7 top-14 w-px bg-gold/40 lg:hidden" data-id="element-132" data-mp="3ae0cay09peod" />
                    <span aria-hidden="true" className="absolute left-[calc(50%+2.25rem)] right-[calc(-50%+2.25rem)] top-7 hidden h-px bg-gold/40 lg:block" data-id="element-133" data-mp="3ka3c3x7nd185" />
                  </>}
                <span className="relative flex h-14 w-14 flex-none items-center justify-center rounded-full bg-white ring-1 ring-gold/50" data-id="element-134" data-mp="3f9flhcnbymeg">
                  <Icon className="h-6 w-6 text-rose-deep" aria-hidden="true" data-id="element-135" data-mp="1ky0vqvubkmyp" />
                </span>
                <div className="pt-1 lg:pt-5" data-id="element-136" data-mp="3l08t0ow8vpno">
                  <p className="font-sans text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-gold-deep" data-id="element-137" data-mp="3l1jwsopowxes">
                    Paso {index + 1}
                  </p>
                  <h3 className="mt-1 font-display text-2xl font-semibold uppercase tracking-[0.08em] text-brown" data-id="element-138" data-mp="3tzdm3fp1eqsg">
                    {step.title}
                  </h3>
                  <p className="mt-1.5 font-sans text-[0.95rem] leading-relaxed text-ink-soft" data-id="element-139" data-mp="7tqjurehzb5w">
                    {step.description}
                  </p>
                </div>
              </li>;
        })}
        </ol>

        <p className="mx-auto mt-14 max-w-2xl text-center font-display text-[1.6rem] font-semibold italic leading-snug text-rose-deep sm:text-3xl" data-id="element-140" data-mp="hk1o6f23fmdb">
          {stepsTagline.map((line, index) => <span key={line} className={index === stepsTagline.length - 1 ? 'block text-brown sm:inline' : 'sm:mr-2'} data-id="element-141" data-mp="qk7yxt6eq88s" data-mpi={index}>
              {line}{' '}
            </span>)}
        </p>
      </div>
    </section>;
}